/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { useForm } from "../hooks/useForm";
import { setCredentials } from "../redux/actions";
import { userLogin } from "../api/api";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactComponent as Logo } from "../images/logoBlue.svg";
import { validateEmail } from "../utils/validate";
import { Scaffold } from "../Scaffold";
import LoadingSpinner from "../LoadingSpinner";
import { useAuth } from "../AuthContext";

export const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [error, setError] = useState("");
  const [textEmailValue, setTextEmailValue] = useState<string>("");
  const [emailValid, setEmailValid] = useState(true);
  const [textPasswordValue, setTextPasswordValue] = useState<string>("");

  const onTextEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextEmailValue(e.target.value);
  };
  const onTextPasswordChange = (e: any) => setTextPasswordValue(e.target.value);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(setCredentials(null));
  }, [dispatch]);

  const initial = {
    username: "",
    password: "",
  };

  const validate = () => {
    setEmailValid(validateEmail(textEmailValue) === true || textEmailValue === "");
    return "";
  };

  const submit = async () => {
    if (!textEmailValue && !textPasswordValue) {
      setError("Please enter login credentials");
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        medleyUserEmail: textEmailValue,
        password: textPasswordValue,
      };
      const response = await userLogin(body);
      const dataObject = response as any;
      dispatch(setCredentials(dataObject));
      globalThis.localStorage.setItem(
        "idToken",
        JSON.stringify(dataObject.idToken)
      );
      const roleType = dataObject.groups.toString();
      login(dataObject.idToken, roleType);
      if (roleType === "rs-admin-group") {
        navigate("/dashboardrsadmin");
      } else if (
        roleType === "guest-experience-group" ||
        roleType === "medley-admin-group" ||
        roleType === "guest-experience-manager-group" ||
        roleType === "compliance-group"
      ) {
        navigate("/dashboard");
      }
    } catch (e) {
      const err = e as AxiosError;
      if (err.response?.status === 403) {
        setError("Please Connect To VPN/Or Contact Support ");
      } else if (err.response?.status === 400) {
        setError("Please Contact Support to Reset Password");
      } else if (err.response?.status === 401) {
        setError("Unable to Login Please Check Credentials");
      } else if (
        err.response?.status === 429 ||
        err.response?.status === 404 ||
        err.response?.status === 500
      ) {
        setError("An Error Occurred Please Contact Support");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const { onSubmit } = useForm({
    initial,
    validate,
    submit,
  });
  return (
    <Scaffold center>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card
          sx={{ width: 400, boxShadow: "0 0 5px 2px #C5C6D0", padding: "30px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo
              style={{
                marginTop: "-30px",
                marginLeft: "40px",
              }}
            />
            <Typography
              variant="h5"
              textAlign="left"
            >
              Sign In
            </Typography>
          </Box>
          <CardContent>
            <Box>
              <Stack spacing={2}>
                <form onSubmit={onSubmit}>
                  <Stack spacing={2}>
                    <TextField
                      onChange={onTextEmailChange}
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      type={"email"}
                      value={textEmailValue}
                      label="Email"
                      error={emailValid !== true}
                      onBlur={validate}
                    />
                    <TextField
                      size="small"
                      autoComplete="current-password"
                      type="password"
                      onChange={onTextPasswordChange}
                      id="outlined-basic"
                      variant="outlined"
                      value={textPasswordValue}
                      label="Password"
                      inputProps={{
                        maxLength: 50,
                      }}
                    />

                    <Button
                      type="submit"
                      variant="contained"
                      onClick={onSubmit}
                      color="primary"
                      size="medium"
                      disabled={
                        Boolean(textEmailValue === "" ||
                        textPasswordValue === "" ||
                        emailValid === false)
                      }
                    >
                      Sign In
                    </Button>
                  </Stack>
                  {error && (
                    <Typography
                      marginTop="10px"
                      marginBottom="0px"
                      variant="body1"
                      color="red"
                      fontWeight="500"
                    >
                      {error}
                    </Typography>
                  )}
                </form>
              </Stack>
            </Box>
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate("/forgotpassword")}
            >
              Forgot Password?
            </Button>
          </CardContent>
        </Card>
      )}
    </Scaffold>
  );
};
